import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Page from 'flow/components/Setting/Page';
import Loading from 'flow/components/ui-components/Loading';
import { routes } from 'flow/types/routes';
import { getTopupLink } from 'flow/utils/mobile-data-utils';
import AppInfo from 'flow/components/AppInfo';
import useMobile from 'flow/hooks/useMobile';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { generatePath } from 'flow/utils/router-utils';

const SettingsUsageExtraData = () => {
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();
    const { mobileSubscription } = useMobile(extensionKey);

    if (!mobileSubscription) {
        return <Loading />;
    }

    return (
        <Page
            header="settings.usage"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.mobile'], { extensionKey }),
                )
            }
        >
            <div className="flex grow flex-col gap-5">
                <object
                    className="h-[510px] shrink-0"
                    data={getTopupLink(mobileSubscription)}
                >
                    <embed src={getTopupLink(mobileSubscription)} />
                </object>

                <AppInfo />
            </div>
        </Page>
    );
};

export default SettingsUsageExtraData;
